import clsx from "clsx";
import { IntegrationStatus } from "../../model/types";
import "./integration-status-tag.scss";

interface IntegrationStatusTagProps {
  status: IntegrationStatus;
}

const STATUS_CONFIG: Record<
  Exclude<IntegrationStatus, null>,
  { label: string; prefix: string; className: string }
> = {
  SENT: {
    label: "Отправлено",
    prefix: "↑",
    className: "integration-status-tag--sent",
  },
  ERROR: {
    label: "Ошибка взаимодействия",
    prefix: "?",
    className: "integration-status-tag--error",
  },
  ACCEPTED: {
    label: "Принято",
    prefix: "✓",
    className: "integration-status-tag--accepted",
  },
  REJECTED: {
    label: "Не принято",
    prefix: "✕",
    className: "integration-status-tag--rejected",
  },
};

export const IntegrationStatusTag = ({ status }: IntegrationStatusTagProps) => {
  if (!status) {
    return <span className="integration-status-tag integration-status-tag--empty">—</span>;
  }

  const config = STATUS_CONFIG[status];

  return (
    <span className={clsx("integration-status-tag", config.className)}>
      <span className="integration-status-tag__prefix">{config.prefix}</span>
      <span className="integration-status-tag__label">{config.label}</span>
    </span>
  );
};
